import { css } from '@emotion/react'

import { colors, elevation, textEllipsis, typo } from '~/@common/styles'

import DropdownItem from './DropdownItem'

const S = {
  basic: {
    wrapper: css`
      position: relative;

      .__dropdown-list {
        display: none;
      }
      .__dropdown-list.open {
        display: block;
      }
    `,
    dropdownButton: css`
      width: 100%;
      height: 100%;
    `,
    dropdownList: css`
      top: 100%;
      z-index: 1;
    `,
    hiddenResult: css`
      position: absolute;
      visibility: hidden;
      z-index: -1;
      left: 0;
      top: 0;
      width: 0;
      height: 0;
    `,
  },
  theme: {
    defaultTheme: {
      wrap: css`
        /* height: 40px; */

        ${DropdownItem} {
          width: 100%;
          padding: 0 12px;
          min-height: 48px;
          border-bottom: 1px solid ${colors.gray.$400};
          color: ${colors.gray.$900};

          &.active {
            .check-icon {
              display: inline-block;
            }
          }
          &:hover:enabled {
            background-color: ${colors.gray.$100};
          }
          &:disabled {
            color: ${colors.gray.$500};
            cursor: not-allowed;
          }
          &:last-child {
            border-bottom: 0 none;
          }
        }
      `,
      list: css`
        position: absolute;
        display: flex;
        flex-direction: column;
        align-items: center;
        top: calc(100% + 4px);
        right: 0;
        max-height: 314px;
        z-index: 1;

        overflow: scroll;

        border: 1px solid ${colors.gray.$400};
        border-radius: var(--Radius-100);
        background: white;
        scrollbar-width: none;
        -webkit-scrollbar-width: none;

        &::-webkit-scrollbar {
          display: none; /* Chrome, Safari, Opera*/
        }
      `,
      button: css`
        display: flex;
        align-items: center;
        justify-content: space-between;

        height: 100%;
        width: 100%;
        padding-left: 12px;
        padding-right: 8px;

        border: 1px solid ${colors.gray.$400};
        border-radius: var(--Radius-100);
        background-color: white;

        path {
          fill: ${colors.gray.$500};
        }

        &.dropdown-open path {
          fill: ${colors.gray.$600};
        }

        &:disabled {
          background-color: ${colors.gray.$100};
          color: ${colors.gray.$500};
        }
        > span {
          text-align: left;
          ${textEllipsis(1)};
        }
      `,
    },

    rounded: {
      wrap: css`
        height: 56px;

        ${DropdownItem} {
          display: flex;
          position: relative;
          align-items: center;
          justify-content: center;

          width: 100%;
          min-height: 48px;
          color: ${colors.gray.$800};

          &:hover {
            background-color: ${colors.gray.$100};
          }
          &.active {
            background-color: ${colors.gray.$100};
            color: ${colors.gray.$900};

            .check-icon {
              display: block;
              position: absolute;
              right: 12px;
            }
          }
        }
      `,
      button: css`
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 100%;

        > strong {
          font-weight: 500;
          margin-right: 8px;
          ${typo.heading05};
        }
        &:disabled {
          cursor: not-allowed;
          background-color: ${colors.gray.$100};
        }
      `,
      list: css`
        position: absolute;
        display: flex;
        flex-direction: column;
        align-items: center;
        left: 8px;
        top: 100%;
        z-index: 1;

        width: calc(100% - 16px);
        max-height: 314px;
        margin-top: 8px;
        overflow: scroll;
        border-radius: var(--Radius-200);
        ${elevation.$01}
        background: white;
        scrollbar-width: none;
        -webkit-scrollbar-width: none;

        &::-webkit-scrollbar {
          display: none; /* Chrome, Safari, Opera*/
        }
      `,
    },
  },
}

export default S
